import WalletFilledIcon from './WalletFilledIcon'

export default WalletFilledIcon
